import { render, staticRenderFns } from "./PriceIndicationsEmpty.vue?vue&type=template&id=617b3107"
import script from "./PriceIndicationsEmpty.vue?vue&type=script&lang=js"
export * from "./PriceIndicationsEmpty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports